import { customerServiceNumberHrefMsg, customerServiceNumberLabelMsg } from '../../common/i18n/index.js';

export type CustomerServiceCallLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'children' | 'href'>;

export const CustomerServiceCallLink = (props: CustomerServiceCallLinkProps) => (
  <a {...props} href={customerServiceNumberHrefMsg}>
    {customerServiceNumberLabelMsg}
  </a>
);
